import React from "react";
import CustomDropdown from "../../../components/input/CustomDropdown";
import SVGraphics from "../../../assets/SVGraphics";

const SliceNavigator = ({ currentIndex, totalSlices, onChange }) => {
  const increment = () => {
    if (currentIndex < totalSlices - 1) onChange(currentIndex + 1);
  };

  const decrement = () => {
    if (currentIndex > 0) onChange(currentIndex - 1);
  };

  const handleSelect = (name, selectedValue) => {
    const selectedIndex = parseInt(selectedValue, 10);
    if (!isNaN(selectedIndex)) {
      onChange(selectedIndex);
    }
  };

  return (
    <div
      className="SliceNavigatorControls flex gap-[0.25rem] p-[0.5625rem] absolute bg-black min-w-[17.625rem] w-fit h-[3rem] text-[#888888] font-[0.75rem]"
      style={{
        zIndex: "40",
        left: "50%",
        bottom: "10%",
        transform: "translateX(-50%)",
      }}>
      {" "}
      <div
        onClick={() => decrement()}
        className="bg-[#333333] min-w-[5.625rem] h-[1.875rem] rounded-[0.625rem] flex items-center gap-2 justify-start p-1 cursor-pointer">
        {" "}
        <SVGraphics svgname="leftNavigateArrow" width="19" height="20" />{" "}
        <p className="w-100 text-center">Previous</p>{" "}
      </div>
      {/* CustomDropdown */}
      <CustomDropdown
        variant="navigation"
        key="current-slice"
        name="slice-picker"
        containerClassName="w-fit rounded-[0.625rem] bg-[#333333] py-1 px-3"
        inputClassName="flex h-auto text-[0.75rem] bg-[#333333] text-white no-select"
        onChange={handleSelect}
        data={Array.from({ length: totalSlices }, (_, index) => ({
          label: `${index}`,
          value: index.toString(),
        }))}
        maxHeight="100%"
        value={currentIndex.toString()}
        placeHolder={currentIndex.toString()}
      />
      <div
        onClick={() => increment()}
        className="bg-[#333333] min-w-[5.625rem] h-[1.875rem] rounded-[0.625rem] flex items-center gap-2 justify-end p-1 cursor-pointer">
        <p className="w-100 text-center">Next</p>
        <SVGraphics svgname="rightNavigateArrow" width="19" height="20" />
      </div>
    </div>
  );
};

export default SliceNavigator;
